/* Producto: galería, selección de variante y agregar al carrito (Cart API nativa). */
(function(){
var dataEl = document.getElementById('pd-data');
var form = document.getElementById('pd-form');
if(!dataEl || !form) return;
var data = JSON.parse(dataEl.textContent);
var variants = data.variants;
var groups = Array.prototype.slice.call(document.querySelectorAll('.pd-sizes'));
var hidden = document.getElementById('pd-variant-id');
var addBtn = document.getElementById('pd-add-btn');
var priceEl = document.getElementById('pd-price');
var errEl = document.getElementById('pd-size-error');
var qtyInput = document.getElementById('pd-qty-input');
var qtyValue = document.getElementById('pd-qty-value');
var selected = data.options.map(function(){ return null; });

/* estado inicial desde el servidor (variante preseleccionada) */
groups.forEach(function(g){
var i = parseInt(g.getAttribute('data-option-index'), 10);
var act = g.querySelector('.pd-size-btn.active');
if(act) selected[i] = act.getAttribute('data-value');
});
if(!groups.length && variants.length === 1){ selected = variants[0].options.slice(); }

function findVariant(){
if(selected.some(function(v){ return v === null; })) return null;
return variants.filter(function(v){ return v.options.every(function(o, i){ return o === selected[i]; }); })[0] || null;
}

function refreshAvailability(){
groups.forEach(function(g){
var i = parseInt(g.getAttribute('data-option-index'), 10);
g.querySelectorAll('.pd-size-btn').forEach(function(btn){
var val = btn.getAttribute('data-value');
var ok = variants.some(function(v){
if(v.options[i] !== val || !v.available) return false;
return v.options.every(function(o, j){ return j === i || selected[j] === null || o === selected[j]; });
});
btn.classList.toggle('is-sold-out', !ok);
btn.disabled = !ok && !btn.classList.contains('active');
});
});
}

function optionError(){
var names = groups.map(function(g, i){ return selected[i] === null ? g.getAttribute('data-option-name') : null; }).filter(Boolean);
var label = (names[0] || 'opción').toLowerCase();
return data.optionErrorLabel + ' ' + label + '.';
}
function markMissingOptions(){
groups.forEach(function(g, i){
var missing = selected[i] === null;
g.classList.toggle('is-error', missing);
if(missing) g.setAttribute('aria-invalid', 'true'); else g.removeAttribute('aria-invalid');
});
}

function render(){
var v = findVariant();
hidden.value = v ? v.id : '';
if(v){
priceEl.innerHTML = (v.compare ? '<s>' + v.compare + '</s> ' : '') + v.price;
addBtn.disabled = !v.available;
addBtn.textContent = v.available ? data.addLabel : data.soldOutLabel;
} else {
priceEl.innerHTML = priceEl.getAttribute('data-default');
addBtn.disabled = !data.productAvailable;
addBtn.textContent = data.productAvailable ? data.addLabel : data.soldOutLabel;
}
refreshAvailability();
}

groups.forEach(function(g){
var i = parseInt(g.getAttribute('data-option-index'), 10);
g.addEventListener('click', function(e){
var btn = e.target.closest('.pd-size-btn');
if(!btn || btn.disabled) return;
g.querySelectorAll('.pd-size-btn').forEach(function(b){ b.classList.remove('active'); b.setAttribute('aria-pressed', 'false'); });
btn.classList.add('active');
btn.setAttribute('aria-pressed', 'true');
selected[i] = btn.getAttribute('data-value');
errEl.hidden = true;
markMissingOptions();
render();
});
});
refreshAvailability();

/* cantidad */
var qty = 1;
function setQty(n){ qty = Math.max(1, n); qtyValue.textContent = qty; qtyInput.value = qty; }
document.getElementById('pd-qty-minus').addEventListener('click', function(){ setQty(qty - 1); });
document.getElementById('pd-qty-plus').addEventListener('click', function(){ setQty(qty + 1); });

/* agregar al carrito (Cart API) */
form.addEventListener('submit', function(e){
e.preventDefault();
var v = findVariant();
if(!v){
errEl.textContent = optionError();
errEl.hidden = false;
markMissingOptions();
errEl.scrollIntoView({ block: 'nearest' });
return;
}
errEl.hidden = true;
markMissingOptions();
if(!v.available || !window.HenuaCart) return;
var idleText = addBtn.textContent;
function restoreAdd(){ addBtn.disabled = false; addBtn.removeAttribute('aria-busy'); addBtn.textContent = idleText; }
addBtn.disabled = true;
addBtn.setAttribute('aria-busy', 'true');
if(data.addingLabel) addBtn.textContent = data.addingLabel;
window.HenuaCart.add(v.id, qty).then(restoreAdd).catch(restoreAdd);
});

/* galería */
var main = document.getElementById('pd-gallery-main');
var thumbs = Array.prototype.slice.call(document.querySelectorAll('.pd-gallery-thumb'));
var mainImg = main ? main.querySelector('img') : null;
var current = 0;
function setMain(i){
if(!thumbs.length || !mainImg) return;
current = (i + thumbs.length) % thumbs.length;
var t = thumbs[current];
mainImg.removeAttribute('srcset');
mainImg.src = t.getAttribute('data-src');
mainImg.alt = t.getAttribute('data-alt');
thumbs.forEach(function(el, k){ el.classList.toggle('active', k === current); el.setAttribute('aria-current', k === current ? 'true' : 'false'); });
t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
}
var warmed = {};
function warm(i){
var t = thumbs[i]; if(!t) return;
var u = t.getAttribute('data-src');
if(!u || warmed[u]) return;
warmed[u] = 1;
var im = new Image(); im.decoding = 'async'; im.src = u;
}
thumbs.forEach(function(t, i){
t.addEventListener('click', function(){ setMain(i); });
t.addEventListener('pointerenter', function(){ warm(i); });
t.addEventListener('focus', function(){ warm(i); });
t.addEventListener('touchstart', function(){ warm(i); }, { passive: true });
});
if(thumbs.length > 1 && !(navigator.connection && navigator.connection.saveData)){
var warmAll = function(){ for(var k = 1; k < thumbs.length && k < 8; k++) warm(k); };
if('requestIdleCallback' in window) requestIdleCallback(warmAll, { timeout: 4000 }); else setTimeout(warmAll, 2500);
}
var prev = document.getElementById('pd-gallery-prev');
var next = document.getElementById('pd-gallery-next');
if(prev) prev.addEventListener('click', function(){ setMain(current - 1); });
if(next) next.addEventListener('click', function(){ setMain(current + 1); });
if(main && thumbs.length > 1){
var startX = null;
main.addEventListener('touchstart', function(e){ startX = e.touches[0].clientX; }, { passive: true });
main.addEventListener('touchend', function(e){
if(startX === null) return;
var d = e.changedTouches[0].clientX - startX;
if(Math.abs(d) > 40) setMain(current + (d < 0 ? 1 : -1));
startX = null;
});
var dragX = null;
main.style.cursor = 'grab';
main.addEventListener('mousedown', function(e){ dragX = e.clientX; });
window.addEventListener('mouseup', function(e){
if(dragX === null) return;
var d = e.clientX - dragX;
if(Math.abs(d) > 40) setMain(current + (d < 0 ? 1 : -1));
dragX = null;
});
}

/* tabs (patrón WAI-ARIA: roles, aria-selected, flechas, Inicio/Fin) */
var tabBtns = Array.prototype.slice.call(document.querySelectorAll('.pd-tab-btn'));
function selectTab(btn, focus){
tabBtns.forEach(function(b){
var on = b === btn;
b.classList.toggle('active', on);
b.setAttribute('aria-selected', on ? 'true' : 'false');
b.setAttribute('tabindex', on ? '0' : '-1');
var panel = document.getElementById(b.getAttribute('data-tab'));
if(panel){ panel.classList.toggle('active', on); panel.hidden = !on; }
});
if(focus) btn.focus();
}
tabBtns.forEach(function(btn, i){
btn.addEventListener('click', function(){ selectTab(btn, false); });
btn.addEventListener('keydown', function(e){
var k = e.key, n = tabBtns.length, t = null;
if(k === 'ArrowRight') t = tabBtns[(i + 1) % n];
else if(k === 'ArrowLeft') t = tabBtns[(i - 1 + n) % n];
else if(k === 'Home') t = tabBtns[0];
else if(k === 'End') t = tabBtns[n - 1];
if(t){ e.preventDefault(); selectTab(t, true); }
});
});
})();
